import {isEqual} from 'lodash';
import {IUserInfo} from '../../../store/auth/atoms';
import {TypeAccountRoles} from '../../../shared/types/user-account.types';

export const getIsUserCustomer = (user?: IUserInfo | null) => {
  if (!user) {
    return false;
  }

  const roles = [...(user.roles ?? [])].filter((role) => role !== TypeAccountRoles.VIEWER).sort();

  return isEqual(roles, [TypeAccountRoles.CUSTOMER]);
};
